<div class="footer-background">
  <div class="footer-left">
    Powered By:
    <img src="assets/images/logo.svg" alt="Company Logo" class="footer-logo">
  </div>
  <div class="footer-center" *ngIf="lastUpdatedDate$ | async as lastUpdated">
    <span class="small text-muted">Last Communicated: {{ formatDate(lastUpdated) }}</span>
  </div>
</div>